export enum UserStudyRole {
  PARTICIPANT = 'participant',
  RESEARCHER = 'researcher',
}

export interface Study {
  studyId: string;
  name: string;
  displayName: string;
  description: string;

  startDate: string;
  completionDate: string;
  expectedParticipants: number;
  expectedParticipantDuration: string;
  numParticipants?: number;
  organizationId?: string;
  organizationName?: string;

  createdAt: string;
}

export interface StudyParticipant {
  studyId: string;
  studyName: string;
  participantId: string;
  givenName: string;
  familyName: string;

  createdAt: string;
}

export interface StudyResearcher {
  studyId: string;
  researcherId: string;
  userId: string;

  isManager: boolean;

  studyName: string;
  studyDisplayName: string;
  researcherGivenName: string;
  researcherFamilyName: string;
  researcherEmail: string;

  createdAt: string;
  updatedAt: string;
}
